// Permisos de la academia (user.academy_roles). La administración tiene todos.
export const ACADEMY_PERMISSIONS = [
  { key: "executive", label: "Ejecutivo" },
  { key: "finance", label: "Finanzas" },
  { key: "reception", label: "Recepción" },
  { key: "academic", label: "Área académica" },
  { key: "instructor", label: "Instructor" },
];

export function academyPermissions(user) {
  if (!user) return [];
  if (user.role === "admin") return ACADEMY_PERMISSIONS.map((p) => p.key);
  return (user.academy_roles || []).filter((k) => ACADEMY_PERMISSIONS.some((p) => p.key === k));
}

// perms vacio = cualquier permiso de academia; si no, al menos uno de la lista.
export function hasAcademyAccess(user, perms = []) {
  const mine = academyPermissions(user);
  if (mine.length === 0) return false;
  return perms.length === 0 || perms.some((p) => mine.includes(p));
}

// A donde va cada usuario cuando entra o cuando abre una pagina que no le toca.
export function homePath(user) {
  return hasAcademyAccess(user) ? "/academia" : "/perfil";
}
